import { Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { WebShopService } from "../../services/webShop.service";
import { Router } from "@angular/router";
import { plopInOut } from "../../shared/animation/component.animation";
import { CoreLanguageService } from "../../services/language.service";
import Utils from "../../shared/utils";
import { ContinueShoppingAction } from "../../shared/contentTypes";
import { take } from "rxjs/internal/operators/take";

interface IContinueShoppingDialogData {
  itemConfig: IItemConfigData;
  isInhOuseGroupOrder?: boolean;
}

interface IExtraItemConfig {
  label: string;
  count: number;
  subIndex: number;
}

interface IItemConfigData {
  // common
  id?: number;
  image: string;
  label: string;
  price: number;
  count: number;
  extras?: IExtraItemConfig[];
  itemGroupId?: number,
  comment?: string;
  // webvoucher specific
  isWebVoucher: boolean;
  isBenefit?: boolean;
  benefitCostPoints?: number
  displayPersonCount?: boolean;
  personCount?: number;
  isFreeAmount?: boolean;
  showDeliveryType: boolean;
  deliveryType: number;
  //ticket specific
  isTicket?: boolean;
  //setting
  canComment?: boolean;

}

export interface IContinueShoppingDialogResult {
  action: ContinueShoppingAction;
  comment?: string;
}

@Component({
  selector: "continueShoppingDialog",
  templateUrl: "./continueShoppingDialog.component.html",
  styleUrls: ["./continueShoppingDialog.component.scss"],
  animations: [plopInOut]
})

export class ContinueShoppingDialogComponent {

  public commentVisibleInitilize: boolean = true;
  @ViewChild('commentBox') commentBox: ElementRef<HTMLTextAreaElement>;

  constructor(public bottomSheetRef: MatBottomSheetRef<ContinueShoppingDialogComponent>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public modalData: IContinueShoppingDialogData
    , private _webShopService: WebShopService
    , private _coreLanguageService: CoreLanguageService
    , private _router: Router) {
  }

  public priceFormatter(price: number): string {
    const me = this;
    return me._webShopService.formatCurrency(price);
  }

  private benefitCostPoints(cost: number): string {
    const me = this;
    return me._coreLanguageService.value("phBenefit_Redeem_Cost_Points_Info").replace("{points}", cost.toString());
  }

  public setItemPrice(iswebVoucher: boolean) {
    const me = this;
    if (me.modalData.itemConfig.isBenefit) {
      return me.benefitCostPoints(me.modalData.itemConfig.benefitCostPoints);
    } else {
      const itemprice = (me.modalData.itemConfig.price) * me.modalData.itemConfig.count;
      return !iswebVoucher ? me.priceFormatter(itemprice) : me.priceFormatter(this.modalData.itemConfig.price)
    }
  }

  public setVoucherPrice() {
    const me = this;
    return (me.modalData.itemConfig.price) * me.modalData.itemConfig.count;
  }

  public setExtraString(): string {
    return this.modalData.itemConfig.extras.filter(e => e.subIndex >= 0).map(e => {
      const single = (e.count > 1 ? e.count + "x " : "") + e.label;
      if (e.subIndex > 0) {
        const subExtras = this.modalData.itemConfig.extras.filter(s => s.subIndex === -e.subIndex);
        if (subExtras.length > 0) {
          return single + "(" + subExtras.map(s => (s.count > 1 ? s.count + "x " : "") + s.label).join(", ") + ")";
        }
      } else {
        return single;
      }
    }).join(", ");
  }


  public isWebVoucherMailDelivery(deliveryType: number) {
    let mailDelivery = 0;
    return deliveryType === mailDelivery ? true : false;
  }

  public navigateToBasket() {
    const me = this;
    me.bottomSheetRef.afterDismissed().pipe(take(1)).subscribe(() => {
      me._router.navigate(["/webshop"]);
    });
    me.bottomSheetRef.dismiss(ContinueShoppingAction.GoToBasket);
  }

  private _setNavigationOnContinue() {
    const me = this;
    if (me.modalData.itemConfig.isWebVoucher) {
      me._router.navigate(["/webVoucherSelector"]);
    } else {
      const itemGroupID = me.modalData.itemConfig.itemGroupId
      if (itemGroupID && itemGroupID > 0) {
        me._router.navigate(["/menu", me.modalData.itemConfig.itemGroupId]);
      } else {
        me._router.navigate(["/menugroup"]);
      }
    }
  }

  public continue() {
    const me = this;
    me.bottomSheetRef.afterDismissed().pipe(take(1)).subscribe(() => {
      me._setNavigationOnContinue();
    });
    me.bottomSheetRef.dismiss(ContinueShoppingAction.GoToMenuGroup);
  }

  //region InHouse GroupOrder

  public showComment() {
    const me = this;
    return me.modalData.itemConfig.canComment && !Utils.IsNullOrEmpty(me.modalData.itemConfig.comment);
  }

  private async setComment() {
    const me = this;
    if (!Utils.IsNullOrEmpty(me.modalData.itemConfig.comment)) {
      console.log("comment: " + me.modalData.itemConfig.comment)
    }
  }

  public closeEmptyTextArea(newText: string, itemID: number) {
    const me = this;
    if (!newText) {
      const itemComment = document.getElementById(`comment${itemID}`);
      const commentLink = document.getElementById(`commentLink${itemID}`);
      itemComment.classList.add("hide-comment");
      commentLink.classList.add("show-anmerkung");
      itemComment.classList.remove("show-comment");
      commentLink.classList.remove("hide-anmerkung");
      me.commentVisibleInitilize = false;
    }
  }

  // open comment text for an item
  public toggleCommentArea(itemID: number) {
    const me = this;
    const itemComment = document.getElementById(`comment${itemID}`);
    const commentLink = document.getElementById(`commentLink${itemID}`);
    itemComment.classList.add("show-comment");
    commentLink.classList.add("hide-anmerkung");
    itemComment.classList.remove("hide-comment");
    commentLink.classList.remove("show-anmerkung");
    me.commentVisibleInitilize = false;
    setTimeout(() => {
      (itemComment.firstChild as HTMLElement).focus();
    }, 600);
  }


  public addToGroupBasket() {
    const result: IContinueShoppingDialogResult = {
      action: ContinueShoppingAction.AddToGroupBasket,
      comment: this.modalData.itemConfig.comment
    };
    this.bottomSheetRef.dismiss(result);
  }

  public orderDirectly() {
    const result: IContinueShoppingDialogResult = {
      action: ContinueShoppingAction.OrderDirectly,
      comment: this.modalData.itemConfig.comment
    };
    this.bottomSheetRef.dismiss(result);
  }

  public groupOverview() {
    this.bottomSheetRef.dismiss(ContinueShoppingAction.Overview);
  }
}

